import { render, staticRenderFns } from "./departmentView.vue?vue&type=template&id=e11c51ba&"
import script from "./departmentView.vue?vue&type=script&lang=js&"
export * from "./departmentView.vue?vue&type=script&lang=js&"
import style0 from "./departmentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports